import type { BoxProps, ContainerProps } from "@chakra-ui/react";
import { Box, Container } from "@chakra-ui/react";
import { motion } from "framer-motion";

export type MotionBoxTypes = Omit<BoxProps, "transition">;
export type MotionContainerTypes = Omit<ContainerProps, "transition">;

export const MotionBox = motion<MotionBoxTypes>(Box);
export const MotionContainer = motion<MotionContainerTypes>(Container);
